import { concantQuery } from "@/utils/concatQuery";
import api from "./api";

/**
 * Get Auction Banners.
 * @param {*} param0
 * @returns
 */
const loadAuctionBanners = ({ take, skip, search }) => {
  const query = concantQuery({ take, skip, search });
  return api.get(`/auction-banners${query}`);
};

/**
 * Add Auction Banner.
 * @param {*} param0
 * @returns
 */
const addAuctionBanner = body => {
  return api.post("/auction-banners", body);
};

/**
 * Update Auction Banner.
 * @param {*} param0
 * @returns
 */
const editAuctionBanner = (auctionBannerId, body) => {
  return api.put(`/auction-banners/${auctionBannerId}`, body);
};

/**
 * Add Auction Banner.
 * @param {*} param0
 * @returns
 */
const deleteAuctionBanner = auctionBannerId => {
  return api.delete(`/auction-banners/${auctionBannerId}`);
};

/**
 * Post upload Banner Image.
 * @param {*} param0
 * @returns
 */
const uploadBannerImage = body => {
  return api.post("/auction-banners/uploads", body);
};

export {
  loadAuctionBanners,
  addAuctionBanner,
  editAuctionBanner,
  deleteAuctionBanner,
  uploadBannerImage
};
